var Backbone = require('backbone');


var SnomedModel = Backbone.Model.extend({
    url: 'https://snomed.reviewandsign.org/snomed/en-edition/v20140731/concepts',

    initialize: function(models, options) {
            if (options && options.params){
                if (options.params.id){
                    this.url += "/" + id;
                }
            }
        },

    parse: function(data){
        data.defaultTerm = data.defaultTerm.replace('(qualifier value)', '').trim();
        return data;
    }
});


module.exports = SnomedModel;


//////////////////
// WEBPACK FOOTER
// ./app/models/snomed-model.js
// module id = 351
// module chunks = 0